import store from "../store";
import Constants from "../config/constants";
import { serviceGetCloneEmployeeImprest } from "../services/EmployeeImprest.service";

export const FETCH_INIT = "FETCH_INIT_CLONE_EMPLOYEE_IMPREST";
export const FETCHED = "FETCHED_CLONE_EMPLOYEE_IMPREST";
export const FETCHED_FAIL = "FETCHED_FAIL_CLONE_EMPLOYEE_IMPREST";
export const FETCHED_FILTER = "FETCHED_FILTER_CLONE_EMPLOYEE_IMPREST";
export const FETCH_NEXT = "FETCH_NEXT_CLONE_EMPLOYEE_IMPREST";
export const FILTER = "FILTER_CLONE_EMPLOYEE_IMPREST";
export const RESET_FILTER = "RESET_FILTER_CLONE_EMPLOYEE_IMPREST";
export const SET_SORTING = "SET_SORTING_CLONE_EMPLOYEE_IMPREST";
export const SET_FILTER = "SET_FILTER_CLONE_EMPLOYEE_IMPREST";
export const SET_PAGE = "SET_PAGE_CLONE_EMPLOYEE_IMPREST";
export const CHANGE_PAGE = "CHANGE_PAGE_CLONE_EMPLOYEE_IMPREST";
export const CHANGE_STATUS = "CHANGE_STATE_CLONE_EMPLOYEE_IMPREST";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_CLONE_EMPLOYEE_IMPREST";
export const CREATE_DATA = "CREATE_CLONE_EMPLOYEE_IMPREST";
export const UPDATE_DATA = "UPDATE_CLONE_EMPLOYEE_IMPREST";
export const DELETE_ITEM = "DELETE_CLONE_EMPLOYEE_IMPREST";

export function actionFetchCloneEmployeeImprest(
  index = 1,
  sorting = {},
  filter = {}
) {
  const request = serviceGetCloneEmployeeImprest({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageCloneEmployeeImprestRequests(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterCloneEmployeeImprestRequests(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionSetPageCloneEmployeeImprestRequests(page) {
  const stateData = store.getState().clone_employeeImprest;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchCloneEmployeeImprest(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
